export interface AccountDeleteConfirmTranslations {
  loading: string;
  loginButton: string;
  title: string;
  desc: string;
  cancelButton: string;
  deleteButton: string;
}

export const accountDeleteConfirmTranslationKeys: AccountDeleteConfirmTranslations = {
  loading: 'loading',
  loginButton: 'loginButton',
  title: 'title',
  desc: 'desc',
  cancelButton: 'cancelButton',
  deleteButton: 'deleteButton',
};

export const accountDeleteConfirmTranslationsEN: AccountDeleteConfirmTranslations = {
  loading: 'Loading...',
  loginButton: 'Login',
  title: 'Delete Account',
  desc: 'Click Delete below to complete account removal. This action is irreversible.',
  cancelButton: 'Cancel',
  deleteButton: 'Delete',
};

export const accountDeleteConfirmTranslationsES: AccountDeleteConfirmTranslations = {
  loading: 'Cargando...',
  loginButton: 'Iniciar sesión',
  title: 'Eliminar cuenta',
  desc: 'Haz clic en Eliminar para completar la eliminación de la cuenta. Esta acción es irreversible.',
  cancelButton: 'Cancelar',
  deleteButton: 'Eliminar',
};
